// src/pages/User/AdminUsersList.js
import React, { Component } from "react";
import { withRouter, Link } from "react-router-dom";
import {Container} from "reactstrap";

import adminUserService from "../../services/api/admin-user-service";

class AdminUsersList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      users: [],
      error: null
    };
  }

  componentDidMount() {
    this.loadUsers();
  }

  

  loadUsers = () => {
  this.setState({ loading: true, error: null });
  

  adminUserService.listAdminUsers()
    .then((users) => {
//       console.log("RAW API USERS --->", users);  // 🔥 ADD THIS
//       console.log("RAW USER SAMPLE", users[0]);
//       users.forEach((u, i) => {
//   console.log(i, " ---> ", u.userType);
// });


      // const filtered = (users || []).filter(u =>
      //   u.userType === "SUB_ADMIN" ||
      //   u.userType === "ADMIN"
      // );

//       const filtered = users.filter(u =>
// ["ADMIN", "SUB_ADMIN"].includes(u.userType?.toUpperCase())
// );

const ALLOWED_PERMISSIONS = [
  "FULL_ACCESS",
  "VEHICLE_LOAD",
  "BUSINESS_LISTING",
  "USERS_LIST",
  "REPORTS",
  "RATE_CARD",
  "CONTACT_US"
];

const filtered = users
  .filter(u =>
    ["ADMIN", "SUB_ADMIN"].includes(u.userType?.toUpperCase())
  )
  .map(u => {
    let cleanPermissions = (u.permissions || [])
      .filter(p => ALLOWED_PERMISSIONS.includes(p))
      .filter((p, i, arr) => arr.indexOf(p) === i);  // unique

    return {
      ...u,
      permissions: cleanPermissions
    };
  });


      console.log("FILTERED USERS --->", filtered); // 🔥 ADD THIS

      this.setState({ users: filtered, loading: false });
    })
    .catch(err => {
      console.error("LOAD USER ERROR:", err);
      this.setState({ error: "Failed to load users", loading: false });
    });
};


  onDelete = (user) => {
    if (!window.confirm(`Delete user ${user.contactName || user.username}?`)) return;
    adminUserService.deleteUser(user.id || user._id)
      .then(() => {
        alert("User deleted");
        this.loadUsers();
      })
      .catch(err => {
        console.error(err);
        alert("Failed to delete user");
      });
  };

  onEdit = (user) => {
    // navigate to create/edit page with id
    const id = user.id || user._id;
    this.props.history.push(`/CreateAdminUser/${id}`);
  };

  onCreate = () => {
    this.props.history.push("/CreateAdminUser");
  };

  render() {
    const { users, loading, error } = this.state;

    return (
      <React.Fragment>
      <div className="page-content">
      <Container fluid>
        <div className="page-title-box d-flex align-items-center justify-content-between">
          <h4 className="mb-0">Manage Users</h4>
          <button className="btn btn-success" onClick={this.onCreate}>Create User</button>
        </div>

        {loading && <p>Loading...</p>}
        {error && <div className="alert alert-danger">{error}</div>}

        <div className="card">
          <div className="card-body">
            <div className="table-responsive">
              <table className="table table-hover table-bordered">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Name</th>
                    <th>Username</th>
                    <th>Email</th>
                    <th>User Type</th>
                    <th>Permissions</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {users.length === 0 && !loading && (
                    <tr><td colSpan="8">No users found</td></tr>
                  )}
                  {users.map((u, idx) => (
                    <tr key={u.id || u._id || idx}>
                      <td>{idx + 1}</td>
                      <td>{u.contactName || u.realm || "-"}</td>
                      <td>{u.username}</td>
                      <td>{u.email || "-"}</td>
                      <td>{u.userType}</td>
                      <td>{(u.permissions || []).join(", ") || "-"}</td>
                      <td>{u.status === "A" ? "Active" : u.status === "I" ? "Inactive" : u.status}</td>
                      <td>
                        <button className="btn btn-sm btn-primary mr-2" onClick={() => this.onEdit(u)}>Edit</button>
                        <button className="btn btn-sm btn-danger" onClick={() => this.onDelete(u)}>Delete</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
       </Container>
      </div>
    </React.Fragment>
    );
  }
}

export default withRouter(AdminUsersList);
